import React from 'react'
import InventoryList from './List'
import { Layout } from 'antd'
import Header from '../../Header'

const { Content } = Layout

const Inventory = (props) => {
  const id = props.match.params.id
  const name =props.match.params.name
  const branch = props.match.params.branch

  return (
    <Layout className='layout'>
      <Header item='trade' />
      <Content style={{ padding: '0 50px' }}>
        <div className='content-auto'>
          <InventoryList id={id} name={name} branch={branch} />
        </div>
      </Content>
    </Layout>
  )
}

export default Inventory
